import { Box, Container, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: "1px solid rgba(16,43,99,0.08)",
        py: 4,
        mt: 2,
        bgcolor: "rgba(255,255,255,0.45)",
      }}
    >
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "center" }}
          spacing={2}
        >
          <Typography variant="body2" sx={{ color: "#4A6086" }}>
            © {new Date().getFullYear()} Axiontek. Tous droits réservés.
          </Typography>

          <Stack
            direction="row"
            spacing={2.5}
            sx={{ flexWrap: "wrap", color: "#102B63" }}
          >
            <Box component={RouterLink} to="/a-propos">À propos</Box>
            <Box component={RouterLink} to="/qui-sommes-nous">Qui sommes-nous</Box>
            <Box component={RouterLink} to="/produits">Nos produits</Box>
            <Box component={RouterLink} to="/services">Nos services</Box>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}